export default {
	import: require("./import").default,
	importPrint: require("./import-print").default,
};
